import Loading from "@/components/loading/Loading";
import { useSearchMessagesAndThreads } from "@/api/queries/MessageQueries";
import { useNavigationStore } from "@/stores/navigation-store";
import { useDebounceWithDelay } from "@/hooks/useDebounce";
import { formatDate } from "@/lib/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    CommandDialog,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@/components/ui/command";

const ChatSearchDialog = () => {
    const { searchIsOpen, setSearchIsOpen } = useNavigationStore();
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounceWithDelay(search);
    const {data: messages, isLoading: isLoadingMessage} = useSearchMessagesAndThreads({limit: 10, query: debouncedSearch, type: "all", page: 1}, debouncedSearch != "");

    const handleResultClick = (result: any) => {
        // Close the search dialog
        setSearchIsOpen(false);
        
        // Navigate to the thread with the message ID as a hash
        navigate(`/chats/${result.threadId}#${result.id}`);
        
        // Clear search
        setSearch("");
    };
    // const { items: messages, isLoading: isLoadingMessage } = useInfiniteScrollMessages({
    //     observer: { threshold: 0.8 },
    //     limit: 5,
    //     enabled: debouncedSearch != "",
    //     filter: {
    //         search: debouncedSearch,
    //         minimalResults: true,
    //     },
    //     threadId: undefined,
    // });

    return (
        <CommandDialog onOpenChange={(open) => setSearchIsOpen(open)} open={searchIsOpen} shouldFilter={false}>
            <CommandInput placeholder="Type to search..." value={search} onValueChange={setSearch} />
            <CommandList>
                {isLoadingMessage ? (
                    <CommandItem className="w-full flex justify-center items-center h-[300px]">
                        <Loading />
                    </CommandItem>
                ) : messages && messages.results.length > 0 ? (
                    <CommandGroup heading="Messages">
                        {messages.results.map((message, index) => (
                            <CommandItem 
                                key={message.id} 
                                value={index.toString()}
                                onSelect={() => handleResultClick(message)}
                                className="cursor-pointer"
                            >
                                <div className="flex flex-col gap-1 w-full">
                                    <div className="text-sm font-medium truncate">
                                        {message.title || `Message from ${message.author?.name || 'Unknown'}`}
                                    </div>
                                    <div className="text-xs text-muted-foreground line-clamp-2">
                                        {message.snippet || message.content}
                                    </div>
                                    <div className="text-xs text-muted-foreground">
                                        {formatDate(new Date(message.createdAt))}
                                    </div>
                                </div>
                            </CommandItem>
                        ))}
                    </CommandGroup>
                ) : (
                    <CommandEmpty>No results found.</CommandEmpty>
                )}
            </CommandList>
        </CommandDialog>
        // <Dialog onOpenChange={(open) => setSearchIsOpen(open)} open={searchIsOpen}>
        //     <DialogTrigger asChild>{children ? children : null}</DialogTrigger>
        //     <DialogContent className="p-0">
        //         {isLoadingMessage ? (
        //             <div className="h-[63vh]">
        //                 <Loading />
        //             </div>
        //         ) : (
        //             <div>
        //                 <Input
        //                     value={search}
        //                     onChange={(e) => setSearch(e.target.value)}
        //                     placeholder="Search..."
        //                     className="h-11 placeholder:text-lg border-none focus-visible:ring-0 shadow-none"
        //                 />

        //                 <div className="max-h-[63vh] overflow-y-auto">
        //                     <SearchResultsList messages={messages} />
        //                     {isFetchingNextPageMessage && <Loading />}
        //                     <div ref={fetchMoreTriggerRef} className="h-1" />
        //                 </div>
        //             </div>
        //         )}
        //     </DialogContent>
        // </Dialog>
    );
};

export default ChatSearchDialog;
